module.exports = __webpack_public_path__ + "img/icon-mail.4ba8db81.svg";